import { DeleteOutlined } from '@ant-design/icons';
import { Modal, Radio } from 'antd';
import * as React from 'react';
import ITreeNode from './ITreeNode';
import { useTranslation } from 'react-i18next';
import AntdCustomButton from '../buttons/AntdCustomButton';

interface FCProps {
  onAction: (action: string, node: any) => void;
  node: ITreeNode;
  hasChildren?: boolean;
}

const DeleteNodeConfirmModal: React.FC<FCProps> = ({ node, onAction, hasChildren = false }) => {
  const [deleteOption, setDeleteOption] = React.useState('move-subpages');
  const [visible, setVisible] = React.useState(false);
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (hasChildren && deleteOption === 'move-subpages') {
      onAction && onAction('delete-and-move-subpages', { node });
    } else {
      onAction && onAction('delete', { node });
    }
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <DeleteOutlined
        className="cursor-pointer"
        style={{
          fontSize: '16px',
          color: '#DB3635'
        }}
        onClick={(e) => {
          e.stopPropagation();
          setVisible(true);
        }}
      />
      <Modal
        title={t('Delete the page?')}
        open={visible}
        onCancel={handleCancel}
        footer={[
          <AntdCustomButton key="cancel" onClick={handleCancel}>
            {t('Cancel')}
          </AntdCustomButton>,
          <AntdCustomButton key="confirm" appearance="important" onClick={handleConfirm}>
            {t('Confirm')}
          </AntdCustomButton>
        ]}
        width={hasChildren ? 700 : 400}
      >
        <div>
          {t('Are you sure you want to delete the selected page?')}
          {hasChildren && (
            <div>
              <div>
                {t(
                  'You are attempting to delete a parent page that has subpages associated with it. Subpages should either be deleted too or kept and moved one level up. Please, specify what should be done to the subpages.'
                )}
              </div>
              <div className="mt-4">
                <Radio.Group
                  onChange={(e) => {
                    setDeleteOption(e.target.value);
                  }}
                  value={deleteOption}>
                  <Radio value={'move-subpages'}>
                    {t('Keep and move subpages')}
                  </Radio>
                  <Radio value={'delete-parent-and-subpages'}>
                    {t('Delete parent and subpages')}
                  </Radio>
                </Radio.Group>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default DeleteNodeConfirmModal;
